import { ng } from '@uirouter/angularjs/lib/angular';
import angular = require('angular');
import { NotificationService } from '../../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../../app.common/modules/common/services/popup.service';
import { IProductIngredient } from '../../../../model/products/IProductIngredient';
import { IProductVariationIngredient } from '../../../../model/products/IProductVariationIngredient';

class ProductVariationIngredientsList implements ng.IController {

    public static $inject = [
        'popupService',
        'notificationService',
        '$translate'];

    public items: IProductVariationIngredient[];
    public ingredients: IProductIngredient[];
    public onIngredientChanged: (item: any) => any;

    constructor(
        public popupService: PopupService,
        public notificationService: NotificationService,
        public $translate: angular.translate.ITranslateService
    ) {
    }

    public async openVariationIngredientsInfo() {
        try {
            await this.popupService.info({
                classPopup: 'alert--redesign modal520',
                title: this.$translate.instant('variation_ingredient_list_title'),
                content: this.$translate.instant('variation_ingredient_info_dialog_content')
            });
        } catch (e) { return; }
    }

    public getMinQuantity(ingredient: IProductVariationIngredient) {
        const foundIngredient = this.ingredients.find((item) => item.ID === ingredient.ID);
        return foundIngredient ? foundIngredient.MinQuantity : null ;
    }

    public ingredientChange(ingredient: any) {
        if (this.onIngredientChanged) {
            this.onIngredientChanged({item: ingredient});
        }
    }
}

angular.module('naut').component('productVariationIngredientsList', {
    template: require('./product-variation-ingredients-list.component.html'),
    controller: ProductVariationIngredientsList,
    controllerAs: 'ctrl',
    bindings: {
        items: '=',
        ingredients: '<',
        isTakeAwayPriceDisabled: '<',
        isEatInPriceDisabled: '<',
        currencyClass: '<',
        onIngredientChanged: '&?',
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/shared/product-variation-ingredients-list/product-variation-ingredients-list.component.ts